import { render, staticRenderFns } from "./QaListItemActionsWrapper.vue?vue&type=template&id=12573203&scoped=true&"
import script from "./QaListItemActionsWrapper.vue?vue&type=script&lang=js&"
export * from "./QaListItemActionsWrapper.vue?vue&type=script&lang=js&"
import style0 from "./QaListItemActionsWrapper.vue?vue&type=style&index=0&id=12573203&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12573203",
  null
  
)

export default component.exports